module.exports = __webpack_public_path__ + "img/jsb.1195e725.jpg";